// extracted by mini-css-extract-plugin
module.exports = {"defaultFont":"fonts_defaultFont__O2COt"};